/*eslint max-len: "off" */

export default {
    scope: 'body',
    defaults: {
        standings: {
            pageName: '@SITE_NAME@: Standings: MiLB Standings',
            events: 'event77,event4,event91,event92,event93,event94,event95',
            channel: 'Standings',
            prop12: 'standings',
            prop13: '@SITE_NAME@: Standings: MiLB Standings'
        }
    },
    app: [
        {
            wire: {
                selector: '#standings-app-root div[tabindex="-1"]', // same hack we use in app
                defaults: 'standings',
                eventType: 'mousedown'
            },
            prop14: '@SITE_NAME@: Standings: MiLB Standings: @DROPDOWN_LABEL@ @DROPDOWN_VALUE@ Select Click'
        },
        {
            wire: {
                selector: '#standings-app-root button[aria-label="Standard"]',
                defaults: 'standings',
                eventType: 'mousedown'
            },
            prop14: '@SITE_NAME@: Standings: MiLB Standings: @STANDARD_ADVANCED@ Stats Click'
        },
        {
            wire: {
                selector: '#standings-app-root button[aria-label="Expanded"]',
                defaults: 'standings',
                eventType: 'mousedown'
            },
            prop14: '@SITE_NAME@: Standings: MiLB Standings: @STANDARD_ADVANCED@ Stats Click'
        },
        {
            wire: {
                selector: '#standings-app-root a[class^="StandingsCustomCellstyle__CellLinkWrapper"]',
                defaults: 'standings',
                eventType: 'mousedown'
            },
            prop14: '@SITE_NAME@: Standings: MiLB Standings: Team Select: @FULL_TEAM_NAME@ Click'
        }
    ]
};
